module.exports = __webpack_public_path__ + "img/LinkedIn_logo.f08c524d.png";